import Fuse from 'fuse.js';
const defaultFuseOptions = {
    findAllMatches: true,
    ignoreLocation: true,
    includeMatches: false,
    includeScore: false,
    isCaseSensitive: false,
    shouldSort: true,
    useExtendedSearch: false,
};
function fuzzySearch(data = [], searchKeys, searchTerm, extraFuseOptions, searchOptions) {
    const fuseOptions = {
        ...defaultFuseOptions,
        ...extraFuseOptions,
        keys: searchKeys,
    };
    // @ts-ignore: library's package.json is wrongly configured
    const fuse = new Fuse(data, fuseOptions);
    return fuse.search(searchTerm, searchOptions);
}
export { fuzzySearch, };
//# sourceMappingURL=fuzzy-search.js.map